import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { MuiMarkdown_V2 } from "../../../Shared/components/MuiMarkdown/MuiMarkdown_V2";
import { OrderSummaryDivider } from "../../../Shared/components/OrderSummary/orderSummarySubComponents";
import { getEmptyCartMessage } from "./emptyCart-helpers";
/**
 * Displays the empty cart markdown, if configured.
 * @param emptyCartDisplayMessage
 * @param myMealsEmptyCartDisplayMessage
 * @param showTopSection
 * @param showEmptyCartMessage
 * @param orderSummaryLocation
 * @returns
 */
export const EmptyCartMessage = ({ emptyCartDisplayMessage, myMealsEmptyCartDisplayMessage, showTopSection, showEmptyCartMessage, orderSummaryLocation, }) => {
    const message = getEmptyCartMessage(orderSummaryLocation, emptyCartDisplayMessage, myMealsEmptyCartDisplayMessage);
    if (!showEmptyCartMessage || !message) {
        return null;
    }
    return (_jsxs(Box, { children: [showTopSection ? _jsx(OrderSummaryDivider, {}) : null, _jsx(Box, Object.assign({ sx: { backgroundColor: grey[100], padding: 1.5, width: "100%" } }, { children: _jsx(MuiMarkdown_V2, { children: message }) }))] }));
};
